import React, { useState, useEffect } from "react"
import { useMemo } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ToastContainer, toast } from "react-toastify"
import { getSubLOBStart } from "store/SuperAdmin/Lob-SubLob-company-income/subLobaction"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import DeleteModal from "components/Common/DeleteModal"
import { Link, useParams, useLocation } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { useDispatch, useSelector } from "react-redux"

// CREATE LOB :
import CreateSUBLOB from "./SubLob"
import UpdateSubLob from "./UpdateSubLob"

const Home = () => {
  const [dmodal, setdModal] = useState(false)

  const [updateData, setUpdateData] = useState()

  const [OpenModal, setOpenModal] = useState(false)
  const [UpdateModal, setUpdatModal] = useState(false)

  const CreateFunc = () => {
    setOpenModal(!OpenModal)
  }

  const OpenUpdateModel = () => {
    setUpdatModal(!UpdateModal)
  }
  const { loading, SUBLOB, updated, Iscreated, deleted } = useSelector(
    state => state.SuperAdminLob
  )
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getSubLOBStart())
  }, [])

  useEffect(() => {
    if (Iscreated) {
      toast.success("subLob IsCreated successfully")
      CreateFunc()
      dispatch(getSubLOBStart())
    }
  }, [Iscreated])

  const handleDelete = id => {}

  const handleUpdate = id => {
    const filterData = SUBLOB.data.filter(item => item.id === id)
    setUpdateData(filterData)
    setUpdatModal(true)
  }

  const columns = useMemo(() => [
    {
      Header: "Sr No",
      Cell: cellProps => {
        return <>{cellProps.row.original.id}</>
      },
    },
    {
      Header: "LOB",
      accessor: "LOB",
      Cell: cellProps => {
        return <>{cellProps.row.original.LOB}</>
      },
    },
    {
      Header: "Sub Lob",
      accessor: "SubLOB",
      Cell: cellProps => {
        return <>{cellProps.row.original.SubLOB}</>
      },
    },

    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: cellProps => {
        const currentDate = new Date()
        const endDate = new Date(cellProps.row.original.end_date)
        return (
          <>
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li
                onClick={() => {
                  handleUpdate(cellProps.row.original.id)
                }}
                className="btn btn-sm btn-soft-info"
                id={`edittooltip-${cellProps.row.original.id}`}
              >
                <i className="mdi mdi-pencil-outline" />
                <UncontrolledTooltip
                  placement="top"
                  target={`edittooltip-${cellProps.row.original.id}`}
                >
                  Edit
                </UncontrolledTooltip>
              </li>
{/* 
              <li>
                <Link
                  to={`/update-policy/${id}/${cellProps.row.original.id}`}
                  onClick={() => {
                    handleDelete(cellProps.row.original.id)
                  }}
                  className="btn btn-sm btn-soft-info"
                  id={`deletetooltip-${cellProps.row.original.id}`}
                >
                  <i className="mdi mdi-delete" />
                  <UncontrolledTooltip
                    placement="top"
                    target={`deletetooltip-${cellProps.row.original.id}`}
                  >
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </li> */}
            </ul>
          </>
        )
      },
    },
  ])

  return (
    <React.Fragment>
      <DeleteModal show={dmodal} />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0 card-title flex-grow-1">Sub LOB</h3>

                    <Button onClick={CreateFunc} className="btn btn-dark">
                      {" "}
                      Create Sub Lob
                    </Button>
                  </div>
                </CardBody>

                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={SUBLOB?.data || []}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    loading={loading}
                    // handleJobClicks={handleJobClicks}
                    isJobListGlobalFilter={false}
                    isPagination={true}
                    iscustomPageSizeOptions={true}
                    isShowingPageLength={true}
                    customPageSize={10}
                    tableClass="table-bordered align-middle nowrap mt-2"
                    paginationDiv="col-sm-12 col-md-7"
                    pagination="pagination justify-content-end pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={OpenModal} toggle={CreateFunc} size="md">
            <ModalHeader toggle={CreateFunc} tag="h4">
              <h3>Add Sub LOB</h3>
            </ModalHeader>
            <ModalBody>
              <CreateSUBLOB />
            </ModalBody>
          </Modal>

          {/* UPDATE MODAL */}
          <Modal isOpen={UpdateModal} toggle={OpenUpdateModel} size="md">
            <ModalHeader toggle={OpenUpdateModel} tag="h4">
              <h3>Update LOB</h3>
            </ModalHeader>
            <ModalBody>
              <UpdateSubLob updateData={updateData} />
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default Home
